export default __webpack_public_path__ + "static/media/logo-javascript.3e60d13a.svg";